import type { NuxtApp } from '#app';

export default defineNuxtPlugin({
  name: 'user-agent',
  parallel: true,
  setup(_nuxtApp) {
    const mainStore = useMainStore();

    if (import.meta.server) {
      // Update once, write to store and hydrate via pinia
      mainStore.updateDevicePlatform({ userAgent: useUserAgent() });
    } else {
      // Keeps value in sync when changing user agent with devtools viewport emulator
      useWindowEventListener('resize', () => mainStore.updateDevicePlatform({ userAgent: useUserAgent() }));
    }
  },
});
